import { actionTypes } from '../constants';

const createInitialState = () => ({ current: undefined });

export const reducer = (state = createInitialState(), { type, payload }) => {
  switch (type) {
    case actionTypes.currentCompanyChanged:
    case actionTypes.createReset: {
      return createInitialState();
    }

    case actionTypes.currentCityChanged: {
      return { ...state, current: payload };
    }

    default:
      return state;
  }
};
